import fetch from 'cross-fetch'; // eslint-disable-line no-unused-vars
import { RSAA, createAction } from 'redux-api-middleware';
import { omit } from 'lodash';
import { push } from 'connected-react-router';
import { addMeta, tranformSuccessPayload, tranformChartPayload, tranformEmptyPayload, transformBodyParams } from './transformers';
import { isQueryChanged, getParamsFromQuery, getQueryFromParams } from '../utils/query';
import Routes from '../utils/routes.js.erb';
import { getTimeZone } from '../utils/Formatters';
import { API_FAILURE, authHeaders } from './index';
import { ghColumnsVisibilityChanged } from './internal';

const fetchChartData = (endpoint, requestEvent, receiveEvent, meta = {}) => {
  return {
    [RSAA]: {
      endpoint,
      headers: authHeaders(),
      method: 'GET',
      types: [addMeta(requestEvent, meta), tranformChartPayload(receiveEvent, meta), API_FAILURE],
      fetch: fetch,
    },
  };
}

export const DASHBOARD_REQUEST = 'DASHBOARD_REQUEST';
export const DASHBOARD_RECEIVE = 'DASHBOARD_RECEIVE';
export const DASHBOARD_UPDATE_RECEIVE = 'DASHBOARD_UPDATE_RECEIVE';

const fetchDashboard = (params, meta = {}) => {
  return {
    [RSAA]: {
      endpoint: Routes.api_dashboard_dashboard_index_path(params),
      headers: authHeaders(),
      method: 'GET',
      types: [addMeta(DASHBOARD_REQUEST, meta), tranformChartPayload(DASHBOARD_RECEIVE, meta), API_FAILURE],
      fetch: fetch,
    },
  }
}

// Fetches dashboard stats
export const loadDashboard = (params, meta = {}) => (dispatch, getState) => {
  const state = getState();
  const query = { ...getParamsFromQuery(params), periods: state.meta.dashboard.periods, init: true, tz: getTimeZone(), ...meta };
  return dispatch(fetchDashboard(query, meta));
}

export const updateDashboard = (params, meta = {}) => (dispatch, getState) => {
  const state = getState();

  let query = { ...state.meta.dashboard, ...params, tz: getTimeZone() };
  if (params.start == null && params.end == null) {
    query.periods = {
      ...query.periods,
      account: 'all',
      asq: 'all',
      asqstats: 'all',
      engagement: 'all',
      interactivity: 'all',
    }
  }

  if (isQueryChanged(state.meta.dashboard, query, 'dashboard')) {
    dispatch(fetchDashboard(query, meta));
    return dispatch(push({ search: getQueryFromParams(query) }));
  }
  return dispatch(fetchDashboard(query, meta));
}

export const DASHBOARD_ACCOUNT_REQUEST = 'DASHBOARD_ACCOUNT_REQUEST';
export const DASHBOARD_ACCOUNT_RECEIVE = 'DASHBOARD_ACCOUNT_RECEIVE';

const fetchDashboardAccount = (params, meta = {}) => {
  return {
    [RSAA]: {
      endpoint: Routes.account_api_dashboard_dashboard_index_path(params),
      headers: authHeaders(),
      method: 'GET',
      types: [addMeta(DASHBOARD_ACCOUNT_REQUEST, meta), tranformChartPayload(DASHBOARD_ACCOUNT_RECEIVE, meta), API_FAILURE],
      fetch: fetch,
    },
  }
}

export const updateDashboardAccount = (meta) => (dispatch, getState) => {
  const state = getState();
  const query = { ...state.meta.dashboard, ...meta, tz: getTimeZone() };
  return dispatch(fetchDashboardAccount(query, meta));
}

export const DASHBOARD_ENGAGEMENT_REQUEST = 'DASHBOARD_ENGAGEMENT_REQUEST';
export const DASHBOARD_ENGAGEMENT_RECEIVE = 'DASHBOARD_ENGAGEMENT_RECEIVE';

const fetchDashboardEngagement = (params, meta = {}) => {
  return {
    [RSAA]: {
      endpoint: Routes.engagement_api_dashboard_dashboard_index_path(params),
      headers: authHeaders(),
      method: 'GET',
      types: [addMeta(DASHBOARD_ENGAGEMENT_REQUEST, meta), tranformChartPayload(DASHBOARD_ENGAGEMENT_RECEIVE, meta), API_FAILURE],
      fetch: fetch,
    },
  }
}

export const updateDashboardPeriod = (meta) => {
  return dispatch => {
    dispatch(updateDashboard(meta))
  }
}

export const updateDashboardEngagement = (meta) => (dispatch, getState) => {
  const state = getState();
  const query = { ...state.meta.dashboard, ...meta, tz: getTimeZone() };
  return dispatch(fetchDashboardEngagement(query, meta));
}

export const DASHBOARD_INTERACTIVITY_REQUEST = 'DASHBOARD_INTERACTIVITY_REQUEST';
export const DASHBOARD_INTERACTIVITY_RECEIVE = 'DASHBOARD_INTERACTIVITY_RECEIVE';

const fetchDashboardInteractivity = (params, meta = {}) => {
  return {
    [RSAA]: {
      endpoint: Routes.interactivity_api_dashboard_dashboard_index_path(params),
      headers: authHeaders(),
      method: 'GET',
      types: [addMeta(DASHBOARD_INTERACTIVITY_REQUEST, meta), tranformChartPayload(DASHBOARD_INTERACTIVITY_RECEIVE, meta), API_FAILURE],
      fetch: fetch,
    },
  }
}

export const updateDashboardInteractivity = (meta) => (dispatch, getState) => {
  const state = getState();
  const query = { ...state.meta.dashboard, ...meta, tz: getTimeZone() };
  return dispatch(fetchDashboardInteractivity(query, meta));
}

export const DASHBOARD_ASQ_REQUEST = 'DASHBOARD_ASQ_REQUEST';
export const DASHBOARD_ASQ_RECEIVE = 'DASHBOARD_ASQ_RECEIVE';

const fetchDashboardASQ = (params, meta = {}) => {
  return {
    [RSAA]: {
      endpoint: Routes.asq_api_dashboard_dashboard_index_path(params),
      headers: authHeaders(),
      method: 'GET',
      types: [addMeta(DASHBOARD_ASQ_REQUEST, meta), tranformChartPayload(DASHBOARD_ASQ_RECEIVE, meta), API_FAILURE],
      fetch: fetch,
    },
  }
}

export const updateDashboardASQ = (meta) => (dispatch, getState) => {
  const state = getState();
  const query = { ...state.meta.dashboard, ...meta, tz: getTimeZone() };
  return dispatch(fetchDashboardASQ(query, meta));
}

export const DASHBOARD_FOLLOW_UP_REQUEST = 'DASHBOARD_FOLLOW_UP_REQUEST';
export const DASHBOARD_FOLLOW_UP_RECEIVE = 'DASHBOARD_FOLLOW_UP_RECEIVE';

const fetchDashboardFollowUp = (params, meta = {}) => {
  return {
    [RSAA]: {
      endpoint: Routes.asq_api_dashboard_dashboard_index_path(params),
      headers: authHeaders(),
      method: 'GET',
      types: [addMeta(DASHBOARD_FOLLOW_UP_REQUEST, meta), tranformChartPayload(DASHBOARD_FOLLOW_UP_RECEIVE, meta), API_FAILURE],
      fetch: fetch,
    },
  }
}

export const updateDashboardFollowUp = (meta) => (dispatch, getState) => {
  const state = getState();
  const query = { ...state.meta.dashboard, ...meta, tz: getTimeZone() };
  return dispatch(fetchDashboardFollowUp(query, meta));
}

export const DASHBOARD_ASQ_STATS_REQUEST = 'DASHBOARD_ASQ_STATS_REQUEST';
export const DASHBOARD_ASQ_STATS_RECEIVE = 'DASHBOARD_ASQ_STATS_RECEIVE';

const fetchDashboardASQStats = (params, meta = {}) => {
  return {
    [RSAA]: {
      endpoint: Routes.asq_stats_api_dashboard_dashboard_index_path(params),
      headers: authHeaders(),
      method: 'GET',
      types: [addMeta(DASHBOARD_ASQ_STATS_REQUEST, meta), tranformChartPayload(DASHBOARD_ASQ_STATS_RECEIVE, meta), API_FAILURE],
      fetch: fetch,
    },
  }
}

export const updateDashboardASQStats = (meta) => (dispatch, getState) => {
  const state = getState();
  const query = { ...state.meta.dashboard, ...meta, tz: getTimeZone() };
  return dispatch(fetchDashboardASQStats(query, meta));
}

export const ACCOUNTS_REQUEST = 'ACCOUNTS_REQUEST';
export const ACCOUNTS_RECEIVE = 'ACCOUNTS_RECEIVE';

const fetchAccounts = (params, meta = {}) => {
  return {
    [RSAA]: {
      endpoint: Routes.api_dashboard_accounts_path(params),
      headers: authHeaders(),
      method: 'GET',
      types: [addMeta(ACCOUNTS_REQUEST, meta), tranformSuccessPayload(ACCOUNTS_RECEIVE, meta), API_FAILURE],
      fetch: fetch,
    },
  }
}

export const loadAccounts = (params, meta = {}) => {
  const query = { ...getParamsFromQuery(params), init: true };
  return fetchAccounts(query, meta);
}

export const updateAccounts = (params, meta = {}) => (dispatch, getState) => {
  const state = getState();
  const query = omit({ ...state.meta.accounts, ...params }, ['per', 'totalPages', 'totalCount']);
  if (isQueryChanged(state.meta.accounts, query, 'accounts')) {
    dispatch(fetchAccounts(query, meta));
    return dispatch(push({ search: getQueryFromParams(query) }));
  }
  return dispatch(fetchAccounts(query, meta));
}

export const ACCOUNT_RESET_PASSWORD_REQUEST = 'ACCOUNT_RESET_PASSWORD_REQUEST';
export const ACCOUNT_RESET_PASSWORD_RECEIVE = 'ACCOUNT_RESET_PASSWORD_RECEIVE';

const postResetPassword = (id, meta) => {
  return {
    [RSAA]: {
      endpoint: Routes.reset_password_api_dashboard_account_path(id),
      headers: authHeaders(),
      method: 'POST',
      types: [ACCOUNT_RESET_PASSWORD_REQUEST, tranformEmptyPayload(ACCOUNT_RESET_PASSWORD_RECEIVE, meta), API_FAILURE],
      fetch: fetch,
    },
  };
}

export const resetPassword = (id, email) => {
  return postResetPassword(id, { email });
}

export const ACCOUNT_UPDATE_REQUEST = 'ACCOUNT_UPDATE_REQUEST';
export const ACCOUNT_UPDATE_RECEIVE = 'ACCOUNT_UPDATE_RECEIVE';

const patchAccount = (id, bodyParams, meta = {}) => {
  return {
    [RSAA]: {
      endpoint: Routes.api_dashboard_account_path(id),
      headers: authHeaders(),
      method: 'PATCH',
      types: [addMeta(ACCOUNT_UPDATE_REQUEST, meta), tranformSuccessPayload(ACCOUNT_UPDATE_RECEIVE, meta), API_FAILURE],
      body: transformBodyParams(bodyParams),
      fetch: fetch,
    },
  };
}

export const updateAccount = (id, params, meta = {}) => {
  return patchAccount(id, params, meta);
}

export const ACCOUNT_REQUEST = 'ACCOUNT_REQUEST';
export const ACCOUNT_RECEIVE = 'ACCOUNT_RECEIVE';

const fetchAccount = (id, meta = {}) => {
  return {
    [RSAA]: {
      endpoint: Routes.api_dashboard_account_path(id),
      headers: authHeaders(),
      method: 'GET',
      types: [addMeta(ACCOUNT_REQUEST, meta), tranformSuccessPayload(ACCOUNT_RECEIVE, meta), API_FAILURE],
      fetch: fetch,
    },
  };
}

export const loadAccount = (params, meta = {}) => {
  return fetchAccount(params.id, meta);
}

export const ACCOUNT_PLAYERS_REQUEST = 'ACCOUNT_PLAYERS_REQUEST';
export const ACCOUNT_PLAYERS_RECEIVE = 'ACCOUNT_PLAYERS_RECEIVE';

const fetchAccountPlayers = (params, meta = {}) => {
  return {
    [RSAA]: {
      endpoint: Routes.api_dashboard_account_players_path(params),
      headers: authHeaders(),
      method: 'GET',
      types: [addMeta(ACCOUNT_PLAYERS_REQUEST, meta), tranformSuccessPayload(ACCOUNT_PLAYERS_RECEIVE, meta), API_FAILURE],
      fetch: fetch,
    },
  };
}

export const loadAccountPlayers = (params, meta = {}) => {
  const query = { ...getParamsFromQuery(params), init: true, tz: getTimeZone() };
  return fetchAccountPlayers(query, meta);
}

export const loadAccountPlayerPreview = (params, meta = {}) => {
  return fetchAccountPlayers(params, meta);
}

export const ENQUEUE_ACCOUNT_PLAYERS_CSV_EXPORT_REQUEST = 'ENQUEUE_ACCOUNT_PLAYERS_CSV_EXPORT_REQUEST ';
export const ENQUEUE_ACCOUNT_PLAYERS_CSV_EXPORT_RECEIVE = 'ENQUEUE_ACCOUNT_PLAYERS_CSV_EXPORT_RECEIVE ';

const postEnqueueAccountPlayersCSVReport = (params, meta) => {
  return async (dispatch, _getState) => {
    const actionResponse = await dispatch(createAction({
      endpoint: Routes.csv_export_api_dashboard_account_players_path(),
      method: 'POST',
      headers: { ...authHeaders(), 'Content-Type': 'application/json' },
      body: transformBodyParams(params),
      types: [
        addMeta(ENQUEUE_ACCOUNT_PLAYERS_CSV_EXPORT_REQUEST, meta),
        tranformSuccessPayload(ENQUEUE_ACCOUNT_PLAYERS_CSV_EXPORT_RECEIVE, meta),
        API_FAILURE,
      ],
      fetch: fetch,
    }));

    if (actionResponse && actionResponse.type === ENQUEUE_ACCOUNT_PLAYERS_CSV_EXPORT_RECEIVE) {
      clearTimeout(scheduleAccountPlayersCSVReportRefreshId);
      dispatch(fetchAccountPlayersCSVReport());
    }

    return actionResponse;
  };
}

export const enqueueAccountPlayersCSVReport = (_params = {}, meta = {}) => (dispatch, getState) => {
  const state = getState();
  const query = omit({ ...state.meta.accountPlayers, tz: getTimeZone() }, ['per', 'totalPages', 'totalCount']);

  return dispatch(postEnqueueAccountPlayersCSVReport(query, meta));
}

export const ACCOUNT_PLAYERS_CSV_REPORT_REQUEST = 'ACCOUNT_PLAYERS_CSV_REPORT_REQUEST';
export const ACCOUNT_PLAYERS_CSV_REPORT_RECEIVE = 'ACCOUNT_PLAYERS_CSV_REPORT_RECEIVE';

const PENDING_ACCOUNT_PLAYERS_CSV_REPORT_STATUSES = ['pending', 'in_progress'];

const fetchAccountPlayersCSVReport = () => {
  return async (dispatch, _getState) => {
    const actionResponse = await dispatch(createAction({
      endpoint: Routes.csv_export_api_dashboard_account_players_path(),
      headers: authHeaders(),
      method: 'GET',
      types: [
        ACCOUNT_PLAYERS_CSV_REPORT_REQUEST,
        tranformSuccessPayload(ACCOUNT_PLAYERS_CSV_REPORT_RECEIVE),
        API_FAILURE,
      ],
      fetch: fetch,
    }));

    if (actionResponse && actionResponse.type === API_FAILURE && actionResponse.payload.status === 429) {
      dispatch(scheduleAccountPlayersCSVReportRefresh());
      return actionResponse.payload.previous;
    }

    if (actionResponse && actionResponse.type === ACCOUNT_PLAYERS_CSV_REPORT_RECEIVE) {
      const { status } = actionResponse.payload;

      if (PENDING_ACCOUNT_PLAYERS_CSV_REPORT_STATUSES.includes(status)) {
        dispatch(scheduleAccountPlayersCSVReportRefresh());
      }
    }

    return actionResponse;
  };
}

export const loadAccountPlayersCSVReport = (interval = window.POLLING_INTERVAL) => {
  return scheduleAccountPlayersCSVReportRefresh(interval);
}

let scheduleAccountPlayersCSVReportRefreshId = null;
const scheduleAccountPlayersCSVReportRefresh = (interval = window.POLLING_INTERVAL) => {
  return (dispatch) => {
    scheduleAccountPlayersCSVReportRefreshId = window.TIMEOUTS.setTimeout(() => {
      dispatch(fetchAccountPlayersCSVReport());
    }, interval);
  }
}

export const updateAccountPlayers = (params, meta = {}) => (dispatch, getState) => {
  const state = getState();
  const query = omit({ ...state.meta.accountPlayers, ...{ ...params, tz: getTimeZone() } }, ['per', 'totalPages', 'totalCount']);
  if (isQueryChanged(state.meta.accountPlayers, query, 'accountPlayers')) {
    dispatch(fetchAccountPlayers(query, meta));
    return dispatch(push({ search: getQueryFromParams(query) }));
  }
  return dispatch(fetchAccountPlayers(query, meta));
}

export const ACCOUNT_PLAYERS_FILTER_REQUEST = 'ACCOUNT_PLAYERS_FILTER_REQUEST';
export const ACCOUNT_PLAYERS_FILTER_RECEIVE = 'ACCOUNT_PLAYERS_FILTER_RECEIVE';

const fetchAccountPlayersFilters = (params, meta = {}) => {
  return {
    [RSAA]: {
      endpoint: Routes.api_dashboard_account_players_filters_path(params),
      headers: authHeaders(),
      method: 'GET',
      types: [addMeta(ACCOUNT_PLAYERS_FILTER_REQUEST, meta), addMeta(ACCOUNT_PLAYERS_FILTER_RECEIVE, meta), API_FAILURE],
      fetch: fetch,
    },
  };
}

export const loadAccountPlayersFilters = (params, meta = {}) => {
  return fetchAccountPlayersFilters(params, meta);
}

export const ACCOUNT_PLAYER_DELETE_REQUEST = 'ACCOUNT_PLAYER_DELETE_REQUEST';
export const ACCOUNT_PLAYER_DELETE_RECEIVE = 'ACCOUNT_PLAYER_DELETE_RECEIVE';

const destroyAccountPlayer = (id, meta) => {
  return {
    [RSAA]: {
      endpoint: Routes.api_dashboard_account_player_path(id),
      headers: authHeaders(),
      method: 'DELETE',
      types: [ACCOUNT_PLAYER_DELETE_REQUEST, tranformEmptyPayload(ACCOUNT_PLAYER_DELETE_RECEIVE, meta), API_FAILURE],
      fetch: fetch,
    },
  };
}

export const deleteAccountPlayer = (id, meta = {}) => {
  return destroyAccountPlayer(id, { ...meta, id });
}

export const ACCOUNT_PLAYER_UPDATE_REQUEST = 'ACCOUNT_PLAYER_UPDATE_REQUEST';
export const ACCOUNT_PLAYER_UPDATE_RECEIVE = 'ACCOUNT_PLAYER_UPDATE_RECEIVE';

const patchResetCohortsAccountPlayer = (id, bodyParams, meta = {}) => {
  return {
    [RSAA]: {
      endpoint: Routes.reset_cohorts_api_dashboard_account_player_path(id),
      headers: authHeaders(),
      method: 'PATCH',
      types: [addMeta(ACCOUNT_PLAYER_RESET_COHORTS_REQUEST, meta), tranformSuccessPayload(ACCOUNT_PLAYER_RESET_COHORTS_RECEIVE, meta), API_FAILURE],
      body: transformBodyParams(bodyParams),
      fetch: fetch,
    },
  };
}

export const resetCohortsAccountPlayer = (id, meta = {}) => {
  return patchResetCohortsAccountPlayer(id, {}, meta);
}

export const ACCOUNT_PLAYER_RESET_COHORTS_REQUEST = 'ACCOUNT_PLAYER_RESET_COHORTS_REQUEST';
export const ACCOUNT_PLAYER_RESET_COHORTS_RECEIVE = 'ACCOUNT_PLAYER_RESET_COHORTS_RECEIVE';

const patchAccountPlayer = (id, bodyParams, meta = {}) => {
  return {
    [RSAA]: {
      endpoint: Routes.api_dashboard_account_player_path(id),
      headers: authHeaders(),
      method: 'PATCH',
      types: [addMeta(ACCOUNT_PLAYER_UPDATE_REQUEST, meta), tranformSuccessPayload(ACCOUNT_PLAYER_UPDATE_RECEIVE, meta), API_FAILURE],
      body: transformBodyParams(bodyParams),
      fetch: fetch,
    },
  };
}

export const updateAccountPlayer = (id, params, meta = {}) => {
  return patchAccountPlayer(id, params, meta);
}

export const ACCOUNT_PLAYER_REQUEST = 'ACCOUNT_PLAYER_REQUEST';
export const ACCOUNT_PLAYER_RECEIVE = 'ACCOUNT_PLAYER_RECEIVE';

const fetchAccountPlayer = (id, params, meta = {}) => {
  return {
    [RSAA]: {
      endpoint: Routes.api_dashboard_account_player_path(id, params),
      headers: authHeaders(),
      method: 'GET',
      types: [addMeta(ACCOUNT_PLAYER_REQUEST, meta), tranformChartPayload(ACCOUNT_PLAYER_RECEIVE, meta), API_FAILURE],
      fetch: fetch,
    },
  };
}

export const loadAccountPlayer = (id, meta = {}) => (dispatch, getState) => {
  const state = getState();
  return dispatch(fetchAccountPlayer(id, { ...state.meta.accountPlayer, tz: getTimeZone() }, meta));
}

export const ACCOUNT_PLAYER_ENGAGEMENT_REQUEST = 'ACCOUNT_PLAYER_ENGAGEMENT_REQUEST';
export const ACCOUNT_PLAYER_ENGAGEMENT_RECEIVE = 'ACCOUNT_PLAYER_ENGAGEMENT_RECEIVE';

export const updateAccountPlayerEngagement = (id, params) => {
  const query = { periods: params, tz: getTimeZone() };
  return fetchChartData(
    Routes.engagement_api_dashboard_account_player_path(id, query),
    ACCOUNT_PLAYER_ENGAGEMENT_REQUEST,
    ACCOUNT_PLAYER_ENGAGEMENT_RECEIVE,
    query,
  );
}

export const ACCOUNT_PLAYER_INTERACTIVITY_REQUEST = 'ACCOUNT_PLAYER_INTERACTIVITY_REQUEST';
export const ACCOUNT_PLAYER_INTERACTIVITY_RECEIVE = 'ACCOUNT_PLAYER_INTERACTIVITY_RECEIVE';

export const updateAccountPlayerInteractivity = (id, params) => {
  const query = { periods: params, tz: getTimeZone() };
  return fetchChartData(
    Routes.interactivity_api_dashboard_account_player_path(id, query),
    ACCOUNT_PLAYER_INTERACTIVITY_REQUEST,
    ACCOUNT_PLAYER_INTERACTIVITY_RECEIVE,
    query,
  );
}

export const ACCOUNT_PLAYER_PLAYS_REQUEST = 'ACCOUNT_PLAYER_PLAYS_REQUEST';
export const ACCOUNT_PLAYER_PLAYS_RECEIVE = 'ACCOUNT_PLAYER_PLAYS_RECEIVE';

export const updateAccountPlayerPlays = (id, params) => {
  const query = { plays: params };
  return fetchChartData(
    Routes.plays_api_dashboard_account_player_path(id, query),
    ACCOUNT_PLAYER_PLAYS_REQUEST,
    ACCOUNT_PLAYER_PLAYS_RECEIVE,
    query,
  );
}

export const ACCOUNT_PLAYER_FREE_PLAYS_REQUEST = 'ACCOUNT_PLAYER_FREE_PLAYS_REQUEST';
export const ACCOUNT_PLAYER_FREE_PLAYS_RECEIVE = 'ACCOUNT_PLAYER_FREE_PLAYS_RECEIVE';

export const updateAccountPlayerFreePlays = (id, params) => {
  const query = { free_plays: params };
  return fetchChartData(
    Routes.free_plays_api_dashboard_account_player_path(id, query),
    ACCOUNT_PLAYER_FREE_PLAYS_REQUEST,
    ACCOUNT_PLAYER_FREE_PLAYS_RECEIVE,
    query,
  );
}

export const DASHBOARD_FILTER_REQUEST = 'DASHBOARD_FILTER_REQUEST';
export const DASHBOARD_FILTER_RECEIVE = 'DASHBOARD_FILTER_RECEIVE';

const fetchDashboardFilters = (meta = {}) => {
  return {
    [RSAA]: {
      endpoint: Routes.api_dashboard_dashboard_filters_path(),
      headers: authHeaders(),
      method: 'GET',
      types: [addMeta(DASHBOARD_FILTER_REQUEST, meta), addMeta(DASHBOARD_FILTER_RECEIVE, meta), API_FAILURE],
      fetch: fetch,
    },
  }
}

export const loadDashboardFilters = (meta = {}) => {
  return fetchDashboardFilters(meta);
}

export const REPORT_GROUP_COHORT_BY_ORGANIZATION_TYPE_REQUEST = 'REPORT_GROUP_COHORT_BY_ORGANIZATION_TYPE_REQUEST';
export const REPORT_GROUP_COHORT_BY_ORGANIZATION_TYPE_RECEIVE = 'REPORT_GROUP_COHORT_BY_ORGANIZATION_TYPE_RECEIVE';

const fetchGroupCohortsByOrganizationType = (params, meta = {}) => {
  return {
    [RSAA]: {
      endpoint: Routes.api_dashboard_organization_type_group_cohorts_path(params),
      headers: authHeaders(),
      method: 'GET',
      types: [addMeta(REPORT_GROUP_COHORT_BY_ORGANIZATION_TYPE_REQUEST, meta), tranformSuccessPayload(REPORT_GROUP_COHORT_BY_ORGANIZATION_TYPE_RECEIVE, meta), API_FAILURE],
      fetch: fetch,
    },
  }
}

export const loadGroupCohortsByOrganizationType = (params, meta = {}) => {
  const query = { ...getParamsFromQuery(params), init: true };
  return fetchGroupCohortsByOrganizationType(query, meta);
}

export const updateGroupCohortsByOrganizationType = (params, meta = {}) => (dispatch, getState) => {
  const state = getState();
  const query = omit({ ...state.meta.groupCohortsByOrganizationType, ...params }, ['per', 'totalPages', 'totalCount']);
  if (isQueryChanged(state.meta.groupCohortsByOrganizationType, query, 'groupCohortsByOrganizationType')) {
    dispatch(fetchGroupCohortsByOrganizationType(query, meta));
    return dispatch(push({ search: getQueryFromParams(query) }));
  }
  return dispatch(fetchGroupCohortsByOrganizationType(query, meta));
}

export const REPORT_GROUP_COHORT_REQUEST = 'REPORT_GROUP_COHORT_REQUEST';
export const REPORT_GROUP_COHORT_RECEIVE = 'REPORT_GROUP_COHORT_RECEIVE';

const fetchGroupCohorts = (params, meta = {}) => {
  return {
    [RSAA]: {
      endpoint: Routes.api_dashboard_group_cohorts_path(params),
      headers: authHeaders(),
      method: 'GET',
      types: [addMeta(REPORT_GROUP_COHORT_REQUEST, meta), tranformSuccessPayload(REPORT_GROUP_COHORT_RECEIVE, meta), API_FAILURE],
      fetch: fetch,
    },
  }
}

export const loadGroupCohorts = (params, meta = {}) => {
  const query = { ...getParamsFromQuery(params), init: true };
  return fetchGroupCohorts(query, meta);
}

export const updateGroupCohorts = (params, meta = {}) => (dispatch, getState) => {
  const state = getState();
  const query = omit({ ...state.meta.groupCohorts, ...params }, ['per', 'totalPages', 'totalCount']);
  if (isQueryChanged(state.meta.groupCohorts, query, 'groupCohorts')) {
    dispatch(fetchGroupCohorts(query, meta));
    return dispatch(push({ search: getQueryFromParams(query) }));
  }
  return dispatch(fetchGroupCohorts(query, meta));
}

export const updateGroupCohortsVisibility = (params, meta = {}) => (dispatch, getState) => {
  const state = getState();
  const query = omit({ ...state.meta.groupCohorts, ...params }, ['per', 'totalPages', 'totalCount']);
  if (isQueryChanged(state.meta.groupCohorts, query, 'groupCohorts')) {
    dispatch(ghColumnsVisibilityChanged(params.withages, meta));
    return dispatch(push({ search: getQueryFromParams(query) }));
  }
  return dispatch(ghColumnsVisibilityChanged(params.withages, meta));
}

export const REPORT_GROUP_COHORT_BY_ORGANIZATION_TYPE_FILTER_REQUEST = 'REPORT_GROUP_COHORT_BY_ORGANIZATION_TYPE_FILTER_REQUEST';
export const REPORT_GROUP_COHORT_BY_ORGANIZATION_TYPE_FILTER_RECEIVE = 'REPORT_GROUP_COHORT_BY_ORGANIZATION_TYPE_FILTER_RECEIVE';

const fetchGroupCohortsByOrganizationTypeFilters = (meta = {}) => {
  return {
    [RSAA]: {
      endpoint: Routes.filters_api_dashboard_organization_type_group_cohorts_path(),
      headers: authHeaders(),
      method: 'GET',
      types: [addMeta(REPORT_GROUP_COHORT_BY_ORGANIZATION_TYPE_FILTER_REQUEST, meta), addMeta(REPORT_GROUP_COHORT_BY_ORGANIZATION_TYPE_FILTER_RECEIVE, meta), API_FAILURE],
      fetch: fetch,
    },
  }
}

export const loadGroupCohortsByOrganizationTypeFilters = (meta = {}) => {
  return fetchGroupCohortsByOrganizationTypeFilters(meta);
}

export const REPORT_GROUP_COHORT_FILTER_REQUEST = 'REPORT_GROUP_COHORT_FILTER_REQUEST';
export const REPORT_GROUP_COHORT_FILTER_RECEIVE = 'REPORT_GROUP_COHORT_FILTER_RECEIVE';

const fetchGroupCohortsFilters = (meta = {}) => {
  return {
    [RSAA]: {
      endpoint: Routes.filters_api_dashboard_group_cohorts_path(),
      headers: authHeaders(),
      method: 'GET',
      types: [addMeta(REPORT_GROUP_COHORT_FILTER_REQUEST, meta), addMeta(REPORT_GROUP_COHORT_FILTER_RECEIVE, meta), API_FAILURE],
      fetch: fetch,
    },
  }
}

export const loadGroupCohortsFilters = (meta = {}) => {
  return fetchGroupCohortsFilters(meta);
}


export const ENQUEUE_USER_ACTIONS_CSV_EXPORT_REQUEST = 'ENQUEUE_USER_ACTIONS_CSV_EXPORT_REQUEST ';
export const ENQUEUE_USER_ACTIONS_CSV_EXPORT_RECEIVE = 'ENQUEUE_USER_ACTIONS_CSV_EXPORT_RECEIVE ';

const postEnqueueUserActionsCSVReport = (params, meta) => {
  return async (dispatch, _getState) => {
    const actionResponse = await dispatch(createAction({
      endpoint: Routes.csv_export_api_dashboard_user_actions_path(),
      method: 'POST',
      headers: { ...authHeaders(), 'Content-Type': 'application/json' },
      body: transformBodyParams(params),
      types: [
        addMeta(ENQUEUE_USER_ACTIONS_CSV_EXPORT_REQUEST, meta),
        tranformSuccessPayload(ENQUEUE_USER_ACTIONS_CSV_EXPORT_RECEIVE, meta),
        API_FAILURE,
      ],
      fetch: fetch,
    }));

    if (actionResponse && actionResponse.type === ENQUEUE_USER_ACTIONS_CSV_EXPORT_RECEIVE) {
      clearTimeout(scheduleUserActionsCSVReportRefreshId);
      dispatch(fetchUserActionsCSVReport());
    }

    return actionResponse;
  };
}

export const enqueueUserActionsCSVReport = (_params = {}, meta = {}) => (dispatch, getState) => {
  const state = getState();
  const query = omit({ ...state.meta.accountPlayers, tz: getTimeZone() }, ['order', 'sort', 'per', 'totalPages', 'totalCount']);

  return dispatch(postEnqueueUserActionsCSVReport(query, meta));
};

export const USER_ACTIONS_CSV_REPORT_REQUEST = 'USER_ACTIONS_CSV_REPORT_REQUEST';
export const USER_ACTIONS_CSV_REPORT_RECEIVE = 'USER_ACTIONS_CSV_REPORT_RECEIVE';

const PENDING_USER_ACTIONS_CSV_REPORT_STATUSES = ['pending', 'in_progress'];

const fetchUserActionsCSVReport = () => {
  return async (dispatch, _getState) => {
    const actionResponse = await dispatch(createAction({
      endpoint: Routes.csv_export_api_dashboard_user_actions_path(),
      headers: authHeaders(),
      method: 'GET',
      types: [
        USER_ACTIONS_CSV_REPORT_REQUEST,
        tranformSuccessPayload(USER_ACTIONS_CSV_REPORT_RECEIVE),
        API_FAILURE,
      ],
      fetch: fetch,
    }));

    if (actionResponse && actionResponse.type === API_FAILURE && actionResponse.payload.status === 429) {
      dispatch(scheduleUserActionsCSVReportRefresh());
      return actionResponse.payload.previous;
    }

    if (actionResponse && actionResponse.type === USER_ACTIONS_CSV_REPORT_RECEIVE) {
      const { status } = actionResponse.payload;

      if (PENDING_USER_ACTIONS_CSV_REPORT_STATUSES.includes(status)) {
        dispatch(scheduleUserActionsCSVReportRefresh());
      }
    }

    return actionResponse;
  };
};

export const loadUserActionsCSVReport = (interval = window.POLLING_INTERVAL) => {
  return scheduleUserActionsCSVReportRefresh(interval);
};

let scheduleUserActionsCSVReportRefreshId = null;
const scheduleUserActionsCSVReportRefresh = (interval = window.POLLING_INTERVAL) => {
  return (dispatch) => {
    scheduleUserActionsCSVReportRefreshId = window.TIMEOUTS.setTimeout(() => {
      dispatch(fetchUserActionsCSVReport());
    }, interval);
  };
};
